// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"3762f04e","245":"efcc588c","453":"4fbf23d8","589":"6d0d4b8c","902":"f0629d59","908":"1a13b624"}[chunkId] + ".chunk.js";
};